import React from 'react';
import Icon from '../../components/AppIcon';

const estados = [
  { label: 'Potencial', count: 0, color: '#60A5FA', bg: 'rgba(96,165,250,0.08)', border: 'rgba(96,165,250,0.20)' },
  { label: 'Activo', count: 0, color: '#34D399', bg: 'rgba(52,211,153,0.08)', border: 'rgba(52,211,153,0.20)' },
  { label: 'Perdido', count: 0, color: '#F87171', bg: 'rgba(248,113,113,0.08)', border: 'rgba(248,113,113,0.20)' },
  { label: 'Recuperado', count: 0, color: '#FBBF24', bg: 'rgba(251,191,36,0.08)', border: 'rgba(251,191,36,0.20)' },
];

const funciones = [
  { label: 'Rutas Comerciales', icon: 'Map', desc: 'Planificación y seguimiento de rutas' },
  { label: 'Visitas', icon: 'MapPin', desc: 'Registro de visitas a clientes' },
  { label: 'Seguimientos', icon: 'Activity', desc: 'Control de seguimientos y recordatorios' },
  { label: 'Objetivos', icon: 'Target', desc: 'Definición y seguimiento de objetivos' },
  { label: 'Oportunidades', icon: 'TrendingUp', desc: 'Pipeline de oportunidades comerciales' },
  { label: 'Comisiones', icon: 'DollarSign', desc: 'Sistema de comisiones por ventas' },
];

const ERPComercial = () => (
  <div className="min-h-screen px-4 py-8 md:px-8" style={{ background: 'linear-gradient(135deg, #0A0A0A 0%, #111111 50%, #0D0D0D 100%)' }}>
    <div className="mb-8">
      <div className="flex items-center gap-3 mb-2">
        <div className="w-10 h-10 rounded-xl flex items-center justify-center flex-shrink-0" style={{ background: 'rgba(251,191,36,0.10)', border: '1px solid rgba(251,191,36,0.25)' }}>
          <span className="text-xl">👥</span>
        </div>
        <div>
          <h1 className="font-oranienbaum font-bold text-white text-3xl tracking-wide">Comercial</h1>
          <p className="font-oranienbaum text-white/40 text-sm">ERP Empresarial · CRM Comercial</p>
        </div>
      </div>
      <div className="mt-3 ml-[52px] h-px w-32" style={{ background: 'linear-gradient(90deg, #FBBF24 0%, transparent 100%)' }} />
    </div>

    <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full mb-8 ml-[52px]" style={{ background: 'rgba(251,191,36,0.06)', border: '1px solid rgba(251,191,36,0.15)' }}>
      <div className="w-1.5 h-1.5 rounded-full bg-[#FBBF24] animate-pulse" />
      <span className="font-oranienbaum text-[#FBBF24]/70 text-xs tracking-widest uppercase">Módulo en construcción · Arquitectura preparada</span>
    </div>

    {/* Estados de clientes */}
    <div className="flex items-center gap-3 mb-5">
      <div className="h-px flex-1" style={{ background: 'rgba(255,255,255,0.06)' }} />
      <h2 className="font-oranienbaum text-white/50 text-xs uppercase tracking-widest px-3">Pipeline Comercial</h2>
      <div className="h-px flex-1" style={{ background: 'rgba(255,255,255,0.06)' }} />
    </div>

    <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-10">
      {estados?.map((e, i) => (
        <div key={i} className="rounded-2xl p-5 flex flex-col gap-3" style={{ background: e?.bg, border: `1px solid ${e?.border}` }}>
          <div className="flex items-center justify-between">
            <span className="font-oranienbaum font-bold text-white/80 text-sm">{e?.label}</span>
            <div className="w-2 h-2 rounded-full" style={{ background: e?.color }} />
          </div>
          <div className="h-8 w-16 rounded-lg" style={{ background: 'rgba(255,255,255,0.05)' }} />
          <p className="font-oranienbaum text-white/30 text-xs">0 clientes</p>
        </div>
      ))}
    </div>

    {/* Funciones */}
    <div className="flex items-center gap-3 mb-5">
      <div className="h-px flex-1" style={{ background: 'rgba(255,255,255,0.06)' }} />
      <h2 className="font-oranienbaum text-white/50 text-xs uppercase tracking-widest px-3">Funciones</h2>
      <div className="h-px flex-1" style={{ background: 'rgba(255,255,255,0.06)' }} />
    </div>

    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
      {funciones?.map((f, i) => (
        <div key={i} className="rounded-2xl p-5 flex flex-col gap-3 hover:scale-[1.01] transition-transform cursor-pointer" style={{ background: 'rgba(255,255,255,0.03)', border: '1px solid rgba(255,255,255,0.08)' }}>
          <div className="w-9 h-9 rounded-xl flex items-center justify-center" style={{ background: 'rgba(251,191,36,0.10)', border: '1px solid rgba(251,191,36,0.20)' }}>
            <Icon name={f?.icon} size={18} className="text-[#FBBF24]" />
          </div>
          <div>
            <h3 className="font-oranienbaum font-bold text-white text-sm mb-1">{f?.label}</h3>
            <p className="font-oranienbaum text-white/35 text-xs leading-relaxed">{f?.desc}</p>
          </div>
          <div className="mt-auto pt-2 border-t border-white/5">
            <span className="font-oranienbaum text-[10px] text-white/25 uppercase tracking-widest">Próximamente</span>
          </div>
        </div>
      ))}
    </div>
  </div>
);

export default ERPComercial;
